var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('div',{staticClass:"col-md-12 home-box"},[_c('Breadcrumbs',{attrs:{"title":'Company Bank Accounts'}}),_c('BankAccTable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }